var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',[_c('base-form',{ref:"form",attrs:{"items":_vm.data,"label-width":"4em"},on:{"submit":_vm.onSubmit}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }